import type { VacationBalance } from './vacation.types';
import { MONTHS_TO_ENTITLEMENT } from './vacationEligibility';

export interface ScheduleDeadline {
    date: string | null;
    variant: 'deadline' | 'entitledFrom' | 'upToDate' | 'allScheduled';
    nextEntitlementDate: string | null;
}

export function resolveScheduleDeadline(
    balance: VacationBalance | null,
    reconciledNextDeadline: string | null
): ScheduleDeadline {
    if (!balance || !balance.eligible) {
        return { date: null, variant: 'deadline', nextEntitlementDate: null };
    }

    if (reconciledNextDeadline) {
        return { date: reconciledNextDeadline, variant: 'deadline', nextEntitlementDate: null };
    }

    if (balance.monthsWorked < MONTHS_TO_ENTITLEMENT && balance.entitledFrom) {
        return { date: balance.entitledFrom, variant: 'entitledFrom', nextEntitlementDate: null };
    }

    const inProgress = balance.periods.find((period) => period.status === 'Accruing');
    const nextEntitlementDate = inProgress?.endDate ?? null;

    const hasScheduledOrPending = (balance.scheduledDays ?? 0) + (balance.pendingDays ?? 0) > 0;

    return {
        date: null,
        variant: hasScheduledOrPending ? 'allScheduled' : 'upToDate',
        nextEntitlementDate,
    };
}
